import { useState, useEffect, useContext, useRef } from "react";
import Images from "./Images";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import Context from "../../storage/context";



const MAKES = [
    "אאודי", "אלפא רומיאו", "אסטון מרטין", "בי אם וי", "בנטלי", "ג'יפ", "דאצ'יה",
    "הונדה", "וולוו", "פולקסווגן", "יגואר", "יונדאי", "לאדה", "לקסוס", "לינקולן",
    "למבורגיני", "לנד רובר", "מאזדה", "מיני", "מיצובישי", "מרצדס", "ניסאן", "סוזוקי",
    "סיאט", "סיטרואן", "סקודה", "פורד", "פורשה", "פיאט", "פיג'ו", "פרארי", "קיה",
    "רנו", "שברולט", "סובארו", "טויוטה", "טסלה", "אופל", "MG", "BYD"
];
const GEARS = [
    "אוטומטי", "ידני", "רובוטי (AMT)", "CVT (רציף)",
    "דואלי (DSG/DCT)", "טיפטרוניק", "פולאוטומט", "חשמלי"
];
const BODY_TYPES = [
    "סדאן", "האצ'בק", "קרוסאובר", "SUV", "רכב שטח", "קבריולה", "קופה",
    "מיניוון", "וואן", "פיקאפ", "ספורטבק", "לימוזינה", "רודסטר", "סטיישן",
];
const MONTHS = [
    "01 – ינואר", "02 – פברואר", "03 – מרץ", "04 – אפריל",
    "05 – מאי", "06 – יוני", "07 – יולי", "08 – אוגוסט",
    "09 – ספטמבר", "10 – אוקטובר", "11 – נובמבר", "12 – דצמבר",
];
const TEST_YEARS = Array.from({ length: 10 }, (_, i) => 2025 + i);


function Checkbox({ checked, onChange, label }) {
    return (
        <label className="ck" onClick={() => onChange(!checked)}>
            <div className={`ck-b${checked ? " on" : ""}`}>
                {checked && <CheckIcon />}
            </div>
            {label}
        </label>
    );
}

const CheckIcon = () => (
    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);


function Field({ label, required, children, full }) {
    return (
        <div className={`f${full ? " full" : ""}`}>
            <label className="f-lbl">
                {label}{required && <span className="f-req"> *</span>}
            </label>
            {children}
        </div>
    );
}

function Sec({ icon, title, children }) {
    return (
        <div className="sec">
            <div className="sec-h">
                <div className="sec-ico">{icon}</div>
                <span className="sec-ttl">{title}</span>
            </div>
            <div className="sec-b">{children}</div>
        </div>
    );
}


function CarEditForm({ onCancel }) {
    const [saving, setSaving] = useState(false);
    const plateRef = useRef();
    let navigate = useNavigate();
    let ctx = useContext(Context);
    let carData;
    let imagesArr;
    if (localStorage.getItem("car") === null) {
        carData = ctx.getSelected;
        imagesArr = []
    } else {
        carData = JSON.parse(localStorage.getItem("car"));
        imagesArr = [];

        const primaryItem = carData["who_is_p"];
        for (let i = 1; i <= 6; i++) {
            const photo = carData[`p_${i}`];

            if (photo && photo !== "") {
                imagesArr.push({
                    url: photo,
                    primary: primaryItem === `p_${i}`
                });
            }
        }

    }
    const [ids, setAllIds] = useState([]);
    let [errors, setErrors] = useState({});

    const [f, setF] = useState({
        plateNumber: carData.car_id, make: carData.car_make, model: carData.car_full_type, year: carData.year, km: carData.km !== "" ? carData.km.replaceAll(",", "") : "",
        testMonth: carData.next_test !== "" && carData.next_test !== null ? carData.next_test.split("/")[0].trim() : "", testYear: carData.next_test && carData.next_test !== null !== "" ? carData.next_test.split("/")[1].trim() : "", hand: carData.hand, cc: carData.engine, gear: carData.gear,
        owner: carData.owner, price: carData.price !== "" ? carData.price.replaceAll(",", "") : "", color: carData.color, bodyType: carData.car_type, note: carData.tag, recommended: carData.recommended === "yes" ? true : false, extra: carData.more_details, isSale: carData.isSale === "yes" ? true : false, tiktok_url: carData.tiktok_url
    });


    const [images, setImages] = useState(imagesArr === undefined ? Array(6).fill("") : imagesArr);
    const set = (k, v) => setF(p => ({ ...p, [k]: v }));

    let [protect, setProtect] = useState(-1);

    useEffect(() => {
        const data = async () => {
            let res = { data: { message: "" } }
            if (localStorage.getItem("token") === null) {
                res.data.message = "no access"
            } else {

                try {
                    res = await axios.get(`${ctx.api_url}/profile`, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`
                        }
                    });
                } catch (err) {
                    res.data.message = "no access"
                }
            }
            if (res.data.message === "Protected data") {
                setProtect(protect + 2)
            } else {
                setProtect(protect + 1);
            }
        }
        data();
    }, [])


    useEffect(() => {
        const data = async () => {

            try {
                const res = await axios.get(`${ctx.api_url}/carsIds`);
                setAllIds(res.data);
            } catch (err) {

            }


        }
        data();
    }, [ctx.delete_car])


    function isValidTikTokUrl(url) {
        if (!url || typeof url !== "string") return false;

        const pattern = /^https?:\/\/(www\.|vm\.|vt\.)?tiktok\.com\/.+/i;

        if (!pattern.test(url)) return false;

        const hasVideo = /\/video\/\d+/.test(url);
        const isShort = /^https?:\/\/(vm|vt)\.tiktok\.com\/.+/.test(url);

        return hasVideo || isShort;
    }
    const onUpdateSave = async (e) => {
        setSaving(true);
        e.preventDefault();
        const form = e.target;
        if (!form.checkValidity()) {
            setSaving(false);
            form.reportValidity();
            return;
        }


        const formData = new FormData();
        formData.append("make", f.make);
        formData.append("model", f.model);
        formData.append("year", f.year);
        formData.append("km", f.km);
        formData.append("testMonth", f.testMonth);
        formData.append("testYear", f.testYear);
        formData.append("hand", f.hand);
        formData.append("cc", f.cc);
        formData.append("gear", f.gear);
        formData.append("owner", f.owner);
        formData.append("price", f.price);
        formData.append("color", f.color);
        formData.append("bodyType", f.bodyType);
        formData.append("note", f.note);
        formData.append("recommended", f.recommended ? "yes" : "no");
        formData.append("extra", f.extra);
        formData.append("isSale", f.isSale ? "yes" : "no");
        formData.append("tiktok_url", f.tiktok_url === undefined ? "" : f.tiktok_url)


        for (let i = 0; i < images.length; i++) {
            if (images[i] !== null) {
                formData.append("images", images[i]?.file === undefined ? images[i].url : images[i].file);
                if (images[i].primary) {
                    formData.append("who_is_p", `p_${i + 1}`);
                }
            } else {
                formData.append("images", "");
            }
        }

        if (localStorage.getItem("car") !== null) {
            await axios.put(`${ctx.api_url}/cars/${f.plateNumber}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            });
            localStorage.removeItem("car");
            navigate("/admin", { replace: true });
        } else {
            if (!errors.plateNumber) {
                formData.append("car_id", f.plateNumber);
                await axios.post(`${ctx.api_url}/cars`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                });
                navigate("/admin", { replace: true });
            } else {
                setSaving(false);
                plateRef.current?.focus();
            }

        }

    }

    const checkPlateNumber = (e) => {
        const re = ids.filter(id => id.car_id === e.target.value);
        set("plateNumber", e.target.value);
        if (re.length !== 0) {
            setErrors(prev => ({
                ...prev,
                plateNumber: "מספר זה כבר קיים במערכת"
            }));
        } else {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.plateNumber;
                return newErrors;
            });
        }

    }





    if (protect === 0) {
        return <Navigate to="/login" replace />;
    } else if (protect === -1) {
        return <></>

    } else if (saving) {
        return <div style={{
            position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(0,0,0,0.6)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 9999
        }}>
            <div style={{
                background: "#0b1622", border: "1px solid rgba(201,168,76,0.3)",
                borderRadius: 16, padding: "32px 48px", textAlign: "center", color: "white"
            }}>
                <div style={{ fontSize: 36, marginBottom: 12 }}>💾</div>
                <div style={{ fontSize: 18, fontWeight: 700 }}>שומר רכב...</div>
                <div style={{ fontSize: 14, color: "#8da0b8", marginTop: 8 }}>אנא המתן</div>
            </div>
        </div>
    } else {
        return (
            <form className="wrap" onSubmit={onUpdateSave} >

                {/* IMAGES */}
                <Sec icon="📷" title="תמונות רכב (עד 6)">
                    <Images images={images} setImages={setImages} />
                </Sec>

                {/* IDENTITY */}
                <Sec icon="🪪" title="פרטי זיהוי">
                    <div className="g g4">
                        <Field label="מספר רכב" required>
                            <input required className="inp" type="number" placeholder="1234567" ref={plateRef}
                                value={f.plateNumber} onChange={checkPlateNumber} disabled={localStorage.getItem("car") !== null} />
                            {errors.plateNumber ? <label className="error-p">{errors.plateNumber}</label> : <></>}
                        </Field>

                        <Field label="יצרן" required>
                            <div className="sw">
                                <select required className="sel" value={f.make} onChange={e => set("make", e.target.value)}>
                                    <option value="">בחר יצרן…</option>
                                    {MAKES.map(m => <option key={m}>{m}</option>)}
                                </select>
                            </div>
                        </Field>

                        <Field label="דגם" required>
                            <input required className="inp" type="text" placeholder="Corolla, Golf…"
                                value={f.model} onChange={e => set("model", e.target.value)} />
                        </Field>

                        <Field label="שנת ייצור" required>
                            <input required className="inp" type="number" placeholder="2021"
                                min="1970" max="2026"
                                value={f.year} onChange={e => set("year", e.target.value)} />
                        </Field>
                    </div>
                </Sec>

                {/* TECHNICAL */}
                <Sec icon="⚙️" title="נתונים טכניים">
                    <div className="g g4">
                        <Field label="קילומטרים" required>
                            <input required className="inp" type="number" placeholder="75000"
                                value={f.km} onChange={e => set("km", e.target.value)} />
                        </Field>

                        <Field label="טסט עד" required>
                            <div className="my">
                                <div className="sw">
                                    <select required className="sel" value={f.testMonth} onChange={e => set("testMonth", e.target.value)}>
                                        <option value="">חודש</option>
                                        {MONTHS.map(m => <option key={m} value={m.split("–")[0].trim()}>{m}</option>)}
                                    </select>
                                </div>
                                <div className="sw">
                                    <select required className="sel" value={f.testYear} onChange={e => set("testYear", e.target.value)}>
                                        <option value="">שנה</option>
                                        {TEST_YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                                    </select>
                                </div>
                            </div>
                        </Field>

                        <Field label='סמ"ק' required>
                            <input required className="inp" type="number" placeholder="1600"
                                value={f.cc} onChange={e => set("cc", e.target.value)} />
                        </Field>

                        <Field label="יד" required>
                            <input required className="inp" type="number" placeholder="1" min="0" max="20"
                                value={f.hand} onChange={e => set("hand", e.target.value)} />
                        </Field>

                        <Field label="גיר" required>
                            <div className="sw">
                                <select required className="sel" value={f.gear} onChange={e => set("gear", e.target.value)}>
                                    <option value="">בחר גיר…</option>
                                    {GEARS.map(g => <option key={g}>{g}</option>)}
                                </select>
                            </div>
                        </Field>

                        <Field label="סוג מרכב" required>
                            <div className="sw">
                                <select required className="sel" value={f.bodyType} onChange={e => set("bodyType", e.target.value)}>
                                    <option value="">בחר מרכב…</option>
                                    {BODY_TYPES.map(b => <option key={b}>{b}</option>)}
                                </select>
                            </div>
                        </Field>

                        <Field label="צבע" required>
                            <input required className="inp" type="text" placeholder="לבן, שחור, אפור…"
                                value={f.color} onChange={e => set("color", e.target.value)} />
                        </Field>

                        <Field label="בעלים">
                            <input className="inp" type="text" placeholder="בעל רכב"
                                value={f.owner} onChange={e => set("owner", e.target.value)} />
                        </Field>
                    </div>
                </Sec>

                {/* PRICE & NOTE */}
                <Sec icon="💰" title="מחיר וסימון">
                    <div className="g g2">
                        <Field label="מחיר" required>
                            <div className="pw">

                                <input required className="inp" type="number" placeholder="65000"
                                    value={f.price} onChange={e => set("price", e.target.value)} />
                                <span className="ps">₪</span>
                            </div>
                        </Field>

                        <Field label="סימון">
                            <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                                <input className="inp" type="text" placeholder='לדוגמה: "מחיר מיוחד"'
                                    value={f.note} onChange={e => set("note", e.target.value)}
                                    style={{ flex: 1, minWidth: 120 }} />
                                <Checkbox
                                    checked={f.recommended}
                                    onChange={v => set("recommended", v)}
                                    label="מומלץ"
                                />
                                <Checkbox
                                    checked={f.isSale}
                                    onChange={v => set("isSale", v)}
                                    label="נמכר?"
                                />
                            </div>
                        </Field>
                    </div>
                </Sec>
                <Sec icon="🎵" title="סרטון">
                    {isValidTikTokUrl(f.tiktok_url) ?
                        <div className="g g2">

                            <Field label="קישור לטיקטוק">
                                <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                                    <input className="inp" type="text" placeholder="https://vt.tiktok...."
                                        value={f.tiktok_url} onChange={e => set("tiktok_url", e.target.value)}
                                        style={{ direction: "ltr", width: "100%" }} />
                                </div>
                            </Field>

                            <a className="tiktok-btn" href={f.tiktok_url} target="_blank" rel="noreferrer">
                                <span className="tiktok-btn__ico">🎵</span>
                                <div>
                                    <div className="tiktok-btn__title">צפה בסרטון הרכב</div>
                                    <div className="tiktok-btn__sub">נפתח ב-TikTok</div>
                                </div>
                                <span className="tiktok-btn__arrow">←</span>
                            </a>

                        </div> :
                        <Field label="קישור לטיקטוק">
                            <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                                <input className="inp" type="text" placeholder="https://vt.tiktok...."
                                    value={f.tiktok_url} onChange={e => set("tiktok_url", e.target.value)}
                                    style={{ direction: "ltr", width: "100%" }} />
                            </div>
                        </Field>
                    }




                </Sec>
                <Sec icon="⚙️" title="נתונים נוספים">
                    <Field label="פרטים" required>
                        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                            <textarea required className="inp" type="text"
                                value={f.extra} onChange={e => set("extra", e.target.value)}
                                style={{ flex: 1, minWidth: 120 }} />

                        </div>
                    </Field>

                </Sec>

                {/* ACTIONS */}
                <div className="sec">
                    <div className="act">
                        <button type="submit" className="bs" disabled={saving}>{localStorage.getItem("car") === null ? "שמור רכב" : "עדכן רכב"}</button>
                        <button type="button" className="bc" onClick={onCancel}>ביטול</button>
                    </div>
                </div>
            </form>
        );
    }
}

export default CarEditForm;